const getDocumentTypeKey = (option) => option?.value ?? option?.key ?? option?.id;

export const getHiddenDocumentTypeKeys = (fieldOptions = []) =>
  fieldOptions
    .filter(
      (option) =>
        option?.additionalAttributes?.hidden === true ||
        option?.additional_attributes?.hidden === true
    )
    .map((option) => String(getDocumentTypeKey(option)));

export const getSelectableDocTypes = (options = [], hiddenKeys = [], currentType = null) => {
  const hiddenKeySet = new Set(hiddenKeys.map(String));
  const currentTypeKey =
    currentType === null || currentType === undefined ? null : String(currentType);

  return options.filter((option) => {
    const optionKey = String(getDocumentTypeKey(option));
    return optionKey === currentTypeKey || !hiddenKeySet.has(optionKey);
  });
};
